import { ComponentProps, ComponentType, ReactNode } from 'react';

import classNames from 'classnames';

import {
  Breadcrumbs as BackstageBreadcrumbs,
  Link,
} from '@backstage/core-components';

import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

import css from './Breadcrumbs.module.css';

export type BreadcrumbsProps = ComponentProps<typeof BackstageBreadcrumbs> & {
  disableMargins?: boolean;
};

export const Breadcrumbs = ({
  className,
  children,
  disableMargins,
}: BreadcrumbsProps) => (
  <BackstageBreadcrumbs
    color="inherit"
    className={classNames(
      css.root,
      { [css.noMargins]: disableMargins },
      className,
    )}
    classes={{ ol: css.ol, li: css.li }}
  >
    {children}
  </BackstageBreadcrumbs>
);

type BreadcrumbIconLinkProps = {
  to: string;
  icon: ComponentType<{ className?: string }>;
  children: ReactNode;
};

export const BreadcrumbIconLink = ({
  to,
  icon: Icon,
  children,
}: BreadcrumbIconLinkProps) => (
  <Link to={to} className={css.iconLink}>
    <Icon />
    <span className={css.iconLinkLabel}>{children}</span>
  </Link>
);

type BreadcrumbTextProps = {
  children: ReactNode;
};

export const BreadcrumbText = ({ children }: BreadcrumbTextProps) => (
  <TooltipRoot>
    <span className={css.breadcrumbText}>{children}</span>
    <Tooltip>{children}</Tooltip>
  </TooltipRoot>
);
